import { render, staticRenderFns } from "./SamplingOrderAdministration.vue?vue&type=template&id=82ab94e4&scoped=true&lang=html&"
import script from "./SamplingOrderAdministration.vue?vue&type=script&lang=js&"
export * from "./SamplingOrderAdministration.vue?vue&type=script&lang=js&"
import style0 from "./SamplingOrderAdministration.vue?vue&type=style&index=0&id=82ab94e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ab94e4",
  null
  
)

export default component.exports